// Lib
import React, { ReactElement } from 'react';

// Utils
import { getElementId, getTitle } from '../../../../common/elements/utils/elementPropertyUtils';

// Hooks
import { useElementTiptapContent } from '../../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import TaskListTitleTiptapEditor, { TaskListTitleTiptapEditorProps } from './TaskListTitleTiptapEditor';

// Types
import { DocumentType } from '../../../../common/tiptap/conversion/elementConversion/elementConversion';

const TaskListTitle = (props: TaskListTitleTiptapEditorProps): ReactElement => {
    const {
        element,
        isFocusedForegroundElement,
        isEditable,
        isEditing,
        isSingleSelected,
        spellCheck,
        currentEditorId,
        startEditing,
        goToNextTaskHandler,
        dispatchHideTitle,
        dispatchUpdateTitle,
    } = props;

    const title = getTitle(element);

    const elementId = getElementId(element);
    const tiptapContent = useElementTiptapContent(title, elementId, DocumentType.textContent);

    return (
        <TaskListTitleTiptapEditor
            element={element}
            title={tiptapContent}
            isFocusedForegroundElement={isFocusedForegroundElement}
            isEditable={isEditable}
            isEditing={isEditing}
            isSingleSelected={isSingleSelected}
            spellCheck={spellCheck}
            currentEditorId={currentEditorId}
            startEditing={startEditing}
            goToNextTaskHandler={goToNextTaskHandler}
            dispatchHideTitle={dispatchHideTitle}
            dispatchUpdateTitle={dispatchUpdateTitle}
        />
    );
};

export default TaskListTitle;
